import { useNavigate, useParams } from 'react-router-dom';
import { BUCKET_LIST } from '../../../constants/routes';
import { BucketForm } from './BucketForm';

export const BucketFormPage = () => {
  const navigate = useNavigate();
  const { bucketId = '' } = useParams();

  return (
    <BucketForm
      key={bucketId}
      isOpen
      onClose={() => navigate(BUCKET_LIST)}
      bucketId={bucketId}
    />
  );
};
